<template>
  <div class="w-full lg:w-[32%] bg-[#1c4848] relative flex flex-col p-8 text-white shrink-0 overflow-hidden">
    <div class="absolute -top-20 -left-20 w-64 h-64 bg-[#ecd79f]/10 blur-[80px] rounded-full" />
    <div class="absolute -bottom-20 -right-20 w-80 h-80 bg-[#ecd79f]/20 blur-[100px] rounded-full" />

    <div class="relative z-10 flex flex-col h-full justify-between">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 backdrop-blur-md">
          <div class="w-1.5 h-1.5 rounded-full bg-[#ecd79f] animate-pulse" />
          <span class="text-[9px] font-bold text-white tracking-widest uppercase">Preview</span>
        </div>
        <span class="text-[10px] font-bold text-[#ecd79f] uppercase tracking-wider">{{ typeLabelProp }}</span>
      </div>

      <div class="flex-1 flex flex-col items-center justify-center -mt-4">
        <div class="relative w-64 aspect-square group">
          <div class="absolute inset-4 bg-[#ecd79f] blur-[50px] opacity-20 group-hover:opacity-30 transition-opacity duration-500" />
          <div class="relative w-full h-full rounded-[32px] overflow-hidden shadow-2xl border border-white/10 bg-[#153838]">
            <img
              v-if="coverImageUrl"
              :src="coverImageUrl"
              alt="Cover"
              class="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700 ease-out"
            >
            <div v-else class="w-full h-full flex items-center justify-center bg-[#153838]">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="text-white/30"><rect width="18" height="18" x="3" y="3" rx="2"/><circle cx="9" cy="9" r="2"/><path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/></svg>
            </div>
          </div>
        </div>
        <div class="text-center mt-8 space-y-2 px-4 w-full">
          <h3 class="text-2xl font-serif text-[#f2f4f4] font-medium leading-tight line-clamp-2">{{ title || 'New Content Title' }}</h3>
          <p class="text-xs font-semibold text-white/40 tracking-wide uppercase">{{ authorName }}</p>
        </div>
      </div>

      <div class="bg-[#153838]/50 backdrop-blur-xl rounded-[24px] p-5 border border-white/10 shadow-lg mt-4">
        <div v-if="!audioUrl" class="rounded-[24px] bg-black/50 flex items-center justify-center py-6 backdrop-blur-sm">
          <p class="text-xs font-bold text-white/90 text-center px-4">Add audio in the form to preview</p>
        </div>
        <AudioPlayer v-else :src="audioUrl" variant="dark" :bar-count="32" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import AudioPlayer from '@/components/audio/AudioPlayer.vue';

const TYPE_LABELS = {
  nasheed: 'Islamic Nasheed',
  story: 'Islamic Story',
  calm_sound: 'Calm Sound',
};

const props = defineProps({
  coverImageUrl: { type: String, default: '' },
  title: { type: String, default: '' },
  authorName: { type: String, default: 'Author Name' },
  type: { type: String, default: 'story' },
  audioUrl: { type: String, default: '' },
});

const typeLabelProp = computed(() => TYPE_LABELS[props.type] || props.type);
</script>
